import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { Callback } from '../../../modules/callback'
import { IFlowSubscriber } from '../../../modules/epflow'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'
import { unescapeHtml } from '../../../modules/utils'
import { exceedsWordLimit } from './description-validation'
Locale.getInstance().registerKeySet('fr', 'create-event-description', {
  eventTitle: 'Décrivez votre événement',
  exhibitionTitle: 'Décrivez votre exposition',
  festivalTitle: 'Décrivez votre festival',
  eventDescription:
    'Remplissez tous les champs ci-dessous pour documenter votre événement de façon complète et fournir un maximum de détails utiles aux usagers de La Vitrine. Lorsque vous avez terminé, cliquez sur “suivant”',
  exhibitionDescription:
    'Remplissez tous les champs ci-dessous pour documenter votre exposition de façon complète et fournir un maximum de détails utiles aux usagers de La Vitrine. Lorsque vous avez terminé, cliquez sur “suivant”.',
  festivalDescription:
    'Remplissez tous les champs ci-dessous pour documenter votre festival de façon complète et fournir un maximum de détails utiles aux usagers de La Vitrine. Lorsque vous avez terminé, cliquez sur "suivant"',
  eventNameFr: "Nom de l'événement - Français*",
  eventNameEn: "Nom de l'événement - Anglais*",
  exhibitionNameFr: "Nom de l'exposition - Français*",
  exhibitionNameEn: "Nom de l'exposition - Anglais*",
  festivalNameFr: 'Nom du festival - Français',
  festivalNameEn: 'Nom du festival - Anglais',
  placeholder: 'Écrivez ici...',
  principalDiscipline: 'Discipline principale*',
  eventDescriptionFr: "Description de l'événement - Français*",
  eventDescriptionEn: "Description de l'événement - Anglais",
  exhibitionDescriptionFr: "Description de l'exposition - Français*",
  exhibitionDescriptionEn: "Description de l'exposition - Anglais",
  festivalDescriptionFr: 'Description du festival - Français',
  festivalDescriptionEn: 'Description du festival - Anglais',
  audience: 'Audience*',
  eventuploadDateCheckbox: 'Je veux choisir à quelle date rendre cet événement visible',
  exhibitionuploadDateCheckbox: 'Je veux choisir à quelle date rendre cette exposition visible',
  festivaluploadDateCheckbox: 'Je veux choisir à partir de quelle date rendre ce festival visible',
  uploadDate: 'Date de mise en ligne*',
  errors: {
    eventNameFr: 'Veuillez entrer le nom de votre événement en français',
    eventNameEn: 'Veuillez entrer le nom de votre événement en anglais',
    languages: 'Veuillez choisir une langue',
    disciplines: 'Veuillez choisir une discipline',
    audiences: 'Veuillez choisir une audience',
    eventDescriptionFr: 'Veuillez entrer la description de votre événement en français',
    eventDescriptionEn: 'Veuillez entrer la description de votre événement en anglais',
    descriptionTooLong: 'La description ne peut dépasser 250 mots',
    uploadDate: 'Veuillez entrer la date de mise en ligne',
    generic: 'Veuillez corriger les erreurs ci-dessous',
  },
})

Locale.getInstance().registerKeySet('en', 'create-event-description', {
  eventTitle: 'Describe your event',
  exhibitionTitle: 'Describe your exhibition',
  festivalTitle: 'Describe your festival',
  eventDescription:
    "Fill in all the fields below to fully document your event and provide La Vitrine users with as many useful details as possible. When you're finished, click “next”.",
  exhibitionDescription:
    'Fill out the form below in order to supply us with a description of the exhibition as detailed as possible for La Vitrine users. When done, click “next”.',
  festivalDescription:
    "Fill in all the fields below to fully document your festival and provide La Vitrine users with as many useful details as possible. When you're finished, click “next”.",
  eventNameFr: 'Name of the event - French*',
  eventNameEn: 'Name of the event - English*',
  exhibitionNameFr: 'Name of the exhibition - French*',
  exhibitionNameEn: 'Name of the exhibition - English*',
  festivalNameFr: 'Name of the festival - French',
  festivalNameEn: 'Name of the festival - English',
  placeholder: 'Write here...',
  principalDiscipline: 'Principal discipline*',
  eventDescriptionFr: 'Description of the event - French*',
  eventDescriptionEn: 'Description of the event - English',
  exhibitionDescriptionFr: 'Description of the exhibition - French*',
  exhibitionDescriptionEn: 'Description of the exhibition - English',
  audience: 'Audience*',
  eventuploadDateCheckbox: 'I want to choose the date to make this event visible',
  exhibitionuploadDateCheckbox: 'I want to choose the date to make this exhibition visible',
  festivaluploadDateCheckbox: 'I want to choose the date to make this festival visible',
  uploadDate: 'Date of upload*',
  errors: {
    eventNameFr: 'Please enter the name of your event in French',
    eventNameEn: 'Please enter the name of your event in English',
    languages: 'Please choose a language',
    disciplines: 'Please choose a discipline',
    audiences: 'Please choose an audience',
    eventDescriptionFr: 'Please enter the description of your event in French',
    descriptionTooLong: 'The description cannot exceed 250 words',
    uploadDate: 'Please enter the upload date',
    generic: 'Please correct the errors below',
  },
})

export interface EventDescriptionData {
  eventNameFr: string
  eventNameEn: string
  eventDescriptionFr: string
  eventDescriptionEn: string
  languages: any
  disciplines: any
  audiences: any
  uploadDate: string
  uploadDateCheckbox: boolean
}
export interface LvcCreateEventDescription {
  flowGroup: string
  flowStep: string
  errors: any
  eventNameFr: string
  eventNameEn: string
  eventDescriptionFr: string
  eventDescriptionEn: string
  languages: any
  disciplines: any
  audiences: any
  uploadDate: string
  uploadDateCheckbox: boolean
}

export class LvcCreateEventDescription
  extends MinzeElement
  implements MinzeElement, IFlowSubscriber
{
  changeCheckboxCb = Callback.attach(this.updateCheckbox.bind(this))
  changeInputCb = Callback.attach(this.onInputChange.bind(this))
  reactive: Reactive = [
    ['showUploadDateField', false],
    ['eventNameFr', '', false],
    ['eventNameEn', '', false],
    ['eventDescriptionFr', '', false],
    ['eventDescriptionEn', '', false],
    ['languages', [], false],
    ['disciplines', [], false],
    ['audiences', [], false],
    ['uploadDate', '', false],
    ['uploadDateCheckbox', false],
    [
      'errors',
      {
        eventNameFr: false,
        eventNameEn: false,
        principalDiscipline: false,
        eventDescriptionFr: false,
        eventDescriptionEn: false,
        languages: false,
        disciplines: false,
        audiences: false,
        uploadDate: false,
        generic: false,
      },
      false,
    ],
    ['eventDescriptionData', {}, false],
  ]
  attrs: Attrs = [
    ['data-type', 'event'],
    ['flow-group', ''],
    ['flow-step', ''],
  ]

  onReady() {
    MainModule.getInstance()?.getFlowManager()?.subscribe(this)
  }

  onDestroy() {
    MainModule.getInstance()?.getFlowManager()?.unsubscribe(this)
  }

  onInputChange() {
    // We save the value of the inputs otherwise if we rerender the value will be lost
    const eventNameFrElement: any = this.select('[name="eventNameFr"]')
    const eventNameEnElement: any = this.select('[name="eventNameEn"]')
    const eventDescriptionFrElement: any = this.select('[name="eventDescriptionFr"]')
    const eventDescriptionEnElement: any = this.select('[name="eventDescriptionEn"]')
    const uploadDateElement: any = this.select('[name="uploadDate"]')

    this.eventNameFr = eventNameFrElement?.value
    this.eventNameEn = eventNameEnElement?.value
    this.eventDescriptionFr = eventDescriptionFrElement?.value
    this.eventDescriptionEn = eventDescriptionEnElement?.value
    this.uploadDate = uploadDateElement?.value

    if (this.uploadDateCheckbox === false || !uploadDateElement) {
      this.uploadDate = ''
    }

    this.eventDescriptionData = {
      eventNameFr: this.eventNameFr,
      eventNameEn: this.eventNameEn,
      languages: this.languages,
      eventDescriptionFr: this.eventDescriptionFr,
      eventDescriptionEn: this.eventDescriptionEn,
      disciplines: this.disciplines,
      audiences: this.audiences,
      uploadDate: this.uploadDate,
      uploadDateCheckbox: this.uploadDateCheckbox,
    }

    // Get the FlowCore instance to save the data
    const flowCore = MainModule.getInstance().getFlowManager().getCore(this.flowGroup)

    if (flowCore) {
      flowCore.save()
    } else {
      console.warn('FlowCore instance not found, Saving aborted.')
    }
  }

  public async serialize(): Promise<unknown> {
    return this.eventDescriptionData
  }

  public async deserialize(stepData: any, data: any): Promise<void> {
    const entireEventData = data as any
    // Determine the data type from the attribute ("event" by default)
    const dataType = this.getAttribute('data-type') || 'event'
    // Use the provided step data if available; otherwise default to an empty object
    const d = (stepData as EventDescriptionData) ?? {}

    if (dataType === 'exhibition') {
      // For exhibitions, load from createExhibitionDescription keys
      this.eventNameFr =
        d.eventNameFr || entireEventData?.createExhibitionDescription?.eventNameFr || ''
      this.eventNameEn =
        d.eventNameEn || entireEventData?.createExhibitionDescription?.eventNameEn || ''
      this.eventDescriptionFr =
        d.eventDescriptionFr ||
        entireEventData?.createExhibitionDescription?.eventDescriptionFr ||
        ''
      this.eventDescriptionEn =
        d.eventDescriptionEn ||
        entireEventData?.createExhibitionDescription?.eventDescriptionEn ||
        ''
      this.disciplines =
        d.disciplines || entireEventData?.createExhibitionDescription?.disciplines || []
      this.languages = d.languages || entireEventData?.createExhibitionDescription?.languages || []
      this.audiences = d.audiences || entireEventData?.createExhibitionDescription?.audiences || []
      this.uploadDate =
        d.uploadDate || entireEventData?.createExhibitionDescription?.uploadDate || ''
      this.uploadDateCheckbox =
        d.uploadDateCheckbox ??
        entireEventData?.createExhibitionDescription?.uploadDateCheckbox ??
        false
    } else {
      // For events
      if (
        entireEventData?.eventSearchOrAddData?.eventName !== '' &&
        entireEventData?.eventSearchOrAddData?.eventName &&
        !d.eventNameFr
      ) {
        this.eventNameFr = entireEventData?.createEventSearchOrAdd?.eventName
      } else {
        this.eventNameFr = d.eventNameFr || ''
        this.eventNameEn = d.eventNameEn || ''
      }
      this.eventDescriptionFr = d.eventDescriptionFr || ''
      this.eventDescriptionEn = d.eventDescriptionEn || ''
      this.disciplines = d.disciplines || []
      this.languages = d.languages || []
      this.audiences = d.audiences || []
      this.uploadDate = d.uploadDate || ''
      this.uploadDateCheckbox = d.uploadDateCheckbox || false
    }

    // Build the combined data object for easy saving later
    this.eventDescriptionData = {
      eventNameFr: this.eventNameFr,
      eventNameEn: this.eventNameEn,
      languages: this.languages,
      eventDescriptionFr: this.eventDescriptionFr,
      eventDescriptionEn: this.eventDescriptionEn,
      disciplines: this.disciplines,
      audiences: this.audiences,
      uploadDate: this.uploadDate,
      uploadDateCheckbox: this.uploadDateCheckbox,
    }

    this.rerender()
  }

  public async validate(): Promise<boolean> {
    const eventNameFrElement: any = this.select('[name="eventNameFr"]')
    const eventNameEnElement: any = this.select('[name="eventNameEn"]')
    const eventDescriptionFrElement: any = this.select('[name="eventDescriptionFr"]')
    const eventDescriptionEnElement: any = this.select('[name="eventDescriptionEn"]')
    const uploadDateCheckboxElement: any = this.select('[name="uploadDateCheckbox"]')
    const uploadDateElement: any = this.select('[name="uploadDate"]')
    const languagesElement: any = this.select('[name="languages"]')
    const uploadDateCheckbox = uploadDateCheckboxElement?.getAttribute('checked')
    const uploadDateCheckboxValue: boolean =
      uploadDateCheckbox === 'true' || uploadDateCheckbox === true

    const eventNameFr = unescapeHtml(eventNameFrElement?.value)
    const eventNameEn = unescapeHtml(eventNameEnElement?.value)
    const eventDescriptionFr = unescapeHtml(eventDescriptionFrElement?.value)
    const eventDescriptionEn = unescapeHtml(eventDescriptionEnElement?.value)
    const uploadDate = unescapeHtml(uploadDateElement?.value)
    const languages = unescapeHtml(languagesElement?.value)

    for (const key in this.errors) {
      this.errors[key] = false
    }

    if (!eventNameFr) {
      this.errors.eventNameFr = Locale.getKey('create-event-description.errors.eventNameFr')
    }

    if (!eventNameEn) {
      this.errors.eventNameEn = Locale.getKey('create-event-description.errors.eventNameEn')
    }

    if (!eventDescriptionFr) {
      this.errors.eventDescriptionFr = Locale.getKey(
        'create-event-description.errors.eventDescriptionFr'
      )
    } else if (exceedsWordLimit(eventDescriptionFr)) {
      this.errors.eventDescriptionFr = Locale.getKey(
        'create-event-description.errors.descriptionTooLong'
      )
    }

    // English description is optional, but if provided it must respect the limit.
    if (exceedsWordLimit(eventDescriptionEn)) {
      this.errors.eventDescriptionEn = Locale.getKey(
        'create-event-description.errors.descriptionTooLong'
      )
    }

    if (this.dataType !== 'festival' && (this.languages.length === 0 || this.languages === '[]')) {
      this.errors.languages = Locale.getKey('create-event-description.errors.languages')
    }

    if (this.disciplines.length === 0 || this.disciplines === '[]') {
      this.errors.disciplines = Locale.getKey('create-event-description.errors.disciplines')
    }

    if (this.audiences.length === 0 || this.audiences === '[]') {
      this.errors.audiences = Locale.getKey('create-event-description.errors.audiences')
    }

    if (uploadDateCheckboxValue && !uploadDate) {
      this.errors.uploadDate = Locale.getKey('create-event-description.errors.uploadDate')
    }

    let hasErrors = false
    for (const key in this.errors) {
      if (this.errors[key]) {
        hasErrors = true
      }
    }

    // if we have errors, go to the top of the page
    // and show generic error message
    if (hasErrors) {
      window.scrollTo(0, 0)
      this.errors.generic = Locale.getKey('create-event-description.errors.generic')
    }

    return !hasErrors
  }

  public async updateCheckbox() {
    let uploadDateCheckboxElement = this.select('[name="uploadDateCheckbox"]')

    if (!uploadDateCheckboxElement) {
      return
    }
    let uploadDateCheckboxString = uploadDateCheckboxElement?.getAttribute('checked') || ''
    this.uploadDateCheckbox = uploadDateCheckboxString === 'true'
    this.uploadDate = ''
    this.onInputChange()
  }

  handleDisciplinesChange(event: any) {
    this.disciplines = decodeURIComponent(event.detail)
    this.onInputChange()
  }

  handleAudiencesChange(event: any) {
    this.audiences = decodeURIComponent(event.detail)
    this.onInputChange()
  }

  handleLanguagesChange(event: any) {
    this.languages = decodeURIComponent(event.detail)
    this.onInputChange()
  }

  html = () => /*html*/ `
  <div class="container">

    <lvc-box mt="24px" textAlign="left">
      <lvc-text font-preset="titleMobileSmall">
        ${Locale.getKey(`create-event-description.${this.dataType}Title`)}
      </lvc-text>
    </lvc-box>

    <lvc-box mt="24px" textAlign="left" color="#1E007D" font-preset="title">
      ${Locale.getKey(`create-event-description.${this.dataType}Description`)}
    </lvc-box>

      <lvc-box mt="12px">
        <lvc-error error="${this.errors.generic}"></lvc-error>
      </lvc-box>
    <lvc-box class="form">
      <lvc-box mt="8px" textAlign="${window.matchMedia(' (max-width: 730px)').matches ? 'left' : 'center'}"></lvc-box>
      <lvc-box mt="24px">
        <lvc-input secondary-style="true" on-change="${this.changeInputCb}" default-value="${this.eventNameFr}" border="1px solid #1E007D" id="event-name-fr" placeholder="${Locale.getKey('create-event-description.placeholder')}" name="eventNameFr" error="${this.errors.eventNameFr}" label="${Locale.getKey(`create-event-description.${this.dataType}NameFr`)}"></lvc-input>
      </lvc-box>
      <lvc-box mt="12px">
        <lvc-input secondary-style="true" on-change="${this.changeInputCb}" default-value="${this.eventNameEn}" border="1px solid #1E007D" id="event-name-en" placeholder="${Locale.getKey('create-event-description.placeholder')}" name="eventNameEn" error="${this.errors.eventNameEn}" label="${Locale.getKey(`create-event-description.${this.dataType}NameEn`)}" ></lvc-input>
      </lvc-box>
      ${
        this.dataType !== 'festival'
          ? `
        <lvc-box mt="16px">
          <lvc-languages-select-field
            name="languages"
            on-change="${this.changeInputCb}"
            default-value="${encodeURIComponent(this.languages)}"
            error="${this.errors.languages}"
          ></lvc-languages-select-field>
        </lvc-box>
      `
          : ''
      }
      <lvc-box mt="12px">
        <lvc-disciplines-field on-change="${this.changeInputCb}" default-value="${encodeURIComponent(this.disciplines)}" error="${this.errors.disciplines}"></lvc-disciplines-field>
      </lvc-box>
      <lvc-box mt="12px">
        <lvc-input secondary-style="true" textarea="true" on-change="${this.changeInputCb}" default-value="${this.eventDescriptionFr}"  id="event-description-fr" placeholder="${Locale.getKey('create-event-description.placeholder')}" name="eventDescriptionFr" error="${this.errors.eventDescriptionFr}" label="${Locale.getKey(`create-event-description.${this.dataType}DescriptionFr`)}" wordLimit="250"></lvc-input>
      </lvc-box>
      <lvc-box mt="12px">
        <lvc-input secondary-style="true" textarea="true" on-change="${this.changeInputCb}" default-value="${this.eventDescriptionEn}" id="event-description-en" placeholder="${Locale.getKey('create-event-description.placeholder')}" name="eventDescriptionEn" error="${this.errors.eventDescriptionEn}" label="${Locale.getKey(`create-event-description.${this.dataType}DescriptionEn`)}" wordLimit="250"></lvc-input>
      </lvc-box>

      <lvc-box mt="12px">
      <lvc-audiences-field default-value="${encodeURIComponent(this.audiences)}" error="${this.errors.audiences}"></lvc-audiences-field>
      </lvc-box>

      <lvc-box mt="12px">
        <lvc-error error="${this.errors.audience}"></lvc-error>
      </lvc-box>


       <lvc-box mt="12px">
        <lvc-checkbox default-value="${this.uploadDateCheckbox}"  on-change="${this.changeCheckboxCb}" label="${Locale.getKey(`create-event-description.${this.dataType}uploadDateCheckbox`)}" name="uploadDateCheckbox"></lvc-checkbox>
      </lvc-box>
      


      ${
        this.uploadDateCheckbox
          ? `
      <lvc-box mt="12px">
        <lvc-datepicker preset="dropdown" type="date" id="upload-date" default-value="${this.uploadDate}" value="${this.uploadDate}" on-change="${this.changeInputCb}" value="${this.uploadDate}" name="uploadDate" label="${Locale.getKey('create-event-description.uploadDate')}" ></lvc-datepicker>
                ${
                  this.errors.uploadDate
                    ? `
          <lvc-box mt="12px" display="flex" width="100%" justifyContent="center">
            <lvc-error error="${this.errors.uploadDate}"></lvc-error>
          </lvc-box>`
                    : ``
                }
        </lvc-box>  
      
      `
          : ``
      }

     



    </lvc-box>
  </div>
    `

  eventListeners: EventListeners = [
    ['lvc-disciplines-field', 'disciplines-field:change', this.handleDisciplinesChange.bind(this)],
    ['lvc-audiences-field', 'audiences-field:change', this.handleAudiencesChange.bind(this)],
    ['lvc-languages-select-field', 'languages-field:change', this.handleLanguagesChange.bind(this)],
    ['lvc-checkbox', 'change', this.updateCheckbox.bind(this)],
  ]
}
